import { EntityLabels, ListPageTitles } from "../../utils/navigation/pageTitles";
import { WasteMovementListPage } from "../WasteReceivedListPage/WasteMovementListPage";

const WasteRemovedListPage = () => (
    <WasteMovementListPage
        config={{
            movementDirection: "Removed",
            listTitle: ListPageTitles.wasteRemoved,
            entityLabel: EntityLabels.wasteRemoved,
            listPath: "/waste-removed",
            editPathPrefix: "/waste-removed",
            description: "Daily waste removed records aligned with EA waste return columns.",
            persistanceKey: "WasteRemovedListPage",
            siteStorageKey: "WasteRemovedListPage.siteId",
        }}
    />
);

export { WasteRemovedListPage };
